import React from 'react';
import PropTypes from 'prop-types';
import { Pagination } from 'react-bootstrap';

const VISIBLE_PAGES = 5;

const Pager = ({ page, pages, onChange }) => {
    if (!pages || pages <= 1) return null;

    const startPage = Math.max(1, Math.min(page - 2, pages - (VISIBLE_PAGES - 1)));
    const endPage = Math.min(pages, startPage + VISIBLE_PAGES - 1);
    const items = [];
    for (let number = startPage; number <= endPage; number++) {
        items.push(
            <Pagination.Item key={number} active={number === page} onClick={() => onChange(number)}>
                {number}
            </Pagination.Item>
        );
    }

    return (
        <div className="d-flex justify-content-center py-3">
            <Pagination className="mb-0">
                <Pagination.Prev disabled={page === 1} onClick={() => onChange(page - 1)} />
                {items}
                <Pagination.Next disabled={page === pages} onClick={() => onChange(page + 1)} />
            </Pagination>
        </div>
    );
};

Pager.propTypes = {
    page: PropTypes.number.isRequired,
    pages: PropTypes.number,
    onChange: PropTypes.func.isRequired
};

export default Pager;
